/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clock': {
    width: 18,
    height: 18,
    viewBox: '0 0 21 20',
    data: '<path d="M11.2902 5C11.2902 4.44769 10.8428 4 10.291 4C9.7391 4 9.29175 4.44769 9.29175 5V11.5352L12.7343 13.832C13.1935 14.1384 13.8139 14.0142 14.12 13.5547C14.4261 13.0952 14.302 12.4743 13.8429 12.168L11.2902 10.4648V5Z" fill="#768692"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.2831 10C20.2831 15.5228 15.8095 20 10.291 20C4.77246 20 0.298828 15.5228 0.298828 10C0.298828 4.47717 4.77246 0 10.291 0C15.8095 0 20.2831 4.47717 20.2831 10ZM18.2847 10C18.2847 14.4183 14.7058 18 10.291 18C5.87616 18 2.29725 14.4183 2.29725 10C2.29725 5.58173 5.87616 2 10.291 2C14.7058 2 18.2847 5.58173 18.2847 10Z" fill="#768692"/>'
  }
})
